import { t } from 'i18next'
import { Item } from '../../../../../store/types'
import i18n from '../../../../../config/i18n'
import Carousel from '../../schedule/carousel/CustomCarousel'
import { environment } from '../../../../../enviroments/enviroment'

const translationBase = 'components.infoSidebar.worklog.carousel.customImport'
const urlBase = `${environment.publicUrl}/assets/image/carousel/info/customImport`

const LIGHT_PL_1 = `${urlBase}/customImport-light-PL-1.png`
const LIGHT_PL_2 = `${urlBase}/customImport-light-PL-2.png`
const LIGHT_PL_3 = `${urlBase}/customImport-light-PL-3.png`
const LIGHT_PL_4 = `${urlBase}/customImport-light-PL-4.png`
const LIGHT_PL_5 = `${urlBase}/customImport-light-PL-5.png`
const LIGHT_PL_6 = `${urlBase}/customImport-light-PL-6.png`

const DARK_PL_1 = `${urlBase}/customImport-dark-PL-1.png`
const DARK_PL_2 = `${urlBase}/customImport-dark-PL-2.png`
const DARK_PL_3 = `${urlBase}/customImport-dark-PL-3.png`
const DARK_PL_4 = `${urlBase}/customImport-dark-PL-4.png`
const DARK_PL_5 = `${urlBase}/customImport-dark-PL-5.png`
const DARK_PL_6 = `${urlBase}/customImport-dark-PL-6.png`

const LIGHT_EN_1 = `${urlBase}/customImport-light-EN-1.png`
const LIGHT_EN_2 = `${urlBase}/customImport-light-EN-2.png`
const LIGHT_EN_3 = `${urlBase}/customImport-light-EN-3.png`
const LIGHT_EN_4 = `${urlBase}/customImport-light-EN-4.png`
const LIGHT_EN_5 = `${urlBase}/customImport-light-EN-5.png`
const LIGHT_EN_6 = `${urlBase}/customImport-light-EN-6.png`

const DARK_EN_1 = `${urlBase}/customImport-dark-EN-1.png`
const DARK_EN_2 = `${urlBase}/customImport-dark-EN-2.png`
const DARK_EN_3 = `${urlBase}/customImport-dark-EN-3.png`
const DARK_EN_4 = `${urlBase}/customImport-dark-EN-4.png`
const DARK_EN_5 = `${urlBase}/customImport-dark-EN-5.png`
const DARK_EN_6 = `${urlBase}/customImport-dark-EN-6.png`

const CustomImportCarousel = () => {
  const isPolish = i18n.language === 'pl'
  const items: Item[] = [
    {
      subtitle: t(`${translationBase}.button.subtitle`),
      description: t(`${translationBase}.button.description`),
      imageLight: isPolish ? LIGHT_PL_1 : LIGHT_EN_1,
      imageDark: isPolish ? DARK_PL_1 : DARK_EN_1,
      key: 'carousel-import-info-workRecord-1',
    },
    {
      subtitle: t(`${translationBase}.selectingFile.subtitle`),
      description: t(`${translationBase}.selectingFile.description`),
      imageLight: isPolish ? LIGHT_PL_2 : LIGHT_EN_2,
      imageDark: isPolish ? DARK_PL_2 : DARK_EN_2,
      key: 'carousel-import-info-workRecord-2',
    },
    {
      subtitle: t(`${translationBase}.dateRange.subtitle`),
      description: t(`${translationBase}.dateRange.description`),
      imageLight: isPolish ? LIGHT_PL_3 : LIGHT_EN_3,
      imageDark: isPolish ? DARK_PL_3 : DARK_EN_3,
      key: 'carousel-worklog-info-workRecord-3',
    },
    {
      subtitle: t(`${translationBase}.selectingProject.subtitle`),
      description: t(`${translationBase}.selectingProject.description`),
      imageLight: isPolish ? LIGHT_PL_4 : LIGHT_EN_4,
      imageDark: isPolish ? DARK_PL_4 : DARK_EN_4,
      key: 'carousel-worklog-info-workRecord-4',
    },
    {
      subtitle: t(`${translationBase}.importType.subtitle`),
      description: t(`${translationBase}.importType.description`),
      imageLight: isPolish ? LIGHT_PL_5 : LIGHT_EN_5,
      imageDark: isPolish ? DARK_PL_5 : DARK_EN_5,
      key: 'carousel-worklog-info-workRecord-5',
    },
    {
      subtitle: t(`${translationBase}.overwritingHours.subtitle`),
      description: t(`${translationBase}.overwritingHours.description`),
      imageLight: isPolish ? LIGHT_PL_6 : LIGHT_EN_6,
      imageDark: isPolish ? DARK_PL_6 : DARK_EN_6,
      key: 'carousel-worklog-info-workRecord-6',
    }
  ]

  return <Carousel title={t(`${translationBase}.title`)} items={items} />
}

export default CustomImportCarousel
